/**
 * Provider for `DCP`
 * @module
 */

var _ = require('optimizely-client-fn');

var alias = require('../helpers/alias');

module.exports = {
  provides: 'dcpData',

  isAsync: true,

  // Ensure that this provider runs immediately (if there is a DCP targeting condition),
  // so that when DCP API functions are called, they can assume that any cached data is valid
  // and that there is an in-flight or completed request in the ProviderStatusStore.
  isLazy: false,

  getter: [
    'stores/global',
    'stores/visitor_id',
    'stores/visitor',
    'sources/dcp',
    function(GlobalStore, VisitorIdStore, VisitorStore, DCPSource) {
      return function(getValue, setValue){
        (__PROFILE__ || __RUM_VERBOSE__) && require('core/env/performance').time('sendDCP');
        var keyfieldLocators = GlobalStore.getDCPKeyfieldLocators();

        var visitorBucketingId = VisitorIdStore.getBucketingId();
        if (!visitorBucketingId) {
          throw new Error('DCP: No bucketingId set');
        }

        var requestOptions = {} as any;

        var dcpProjectId = GlobalStore.getProjectId();
        var snippetId = GlobalStore.getSnippetId();

        if (snippetId === dcpProjectId) {
          var dcpServiceId = GlobalStore.getDCPServiceId();
          if (!dcpServiceId) {
            throw new Error('DCP: No dcpServiceId configured in Snippet');
          }

          // Multi-project snippet
          _.extend(requestOptions, {
            dcpServiceId: GlobalStore.getDCPServiceId(),
            snippetId: snippetId,
          });
        } else {
          var optlyDatasource = _.find(keyfieldLocators, function(item) {
            return item.is_optimizely;
          });

          if (!optlyDatasource || !optlyDatasource.dcp_datasource_id) {
            // Should never happen.
            throw new Error('DCP: No Optimizely datasource found in keyfield locators for Project');
          }

          _.extend(requestOptions, {
            projectId: dcpProjectId,
            optlyDatasourceId: optlyDatasource.dcp_datasource_id,
          });
        }

        var cachedData = getValue() || {};

        var currentAliases = alias.getCurrentAliases(keyfieldLocators, visitorBucketingId);
        var cacheIsStillValid = _.matches(currentAliases)(cachedData.aliases || {});

        if (!cacheIsStillValid) {
          // Invalidate the cached DCP targeting data, because it's predicated on aliases
          // that we know to be out of date.
          setValue(undefined);
        }

        _.extend(requestOptions, {
          uid: visitorBucketingId,
          currentAliases: currentAliases,
        });
        return DCPSource.fetchDCPData(requestOptions);
      };
    },
  ],
};
